/* estrora-motion.js — apparitions au défilement et affordance de la rangée produits.
 *
 * Pourquoi du code maison et pas une bibliothèque : il n'y a que deux gestes à
 * couvrir, IntersectionObserver les fait nativement, et une dépendance de 30 ko
 * pour ça coûterait plus cher en vitesse que le mouvement ne rapporte.
 *
 * Règles tenues :
 * — `prefers-reduced-motion` coupe tout, sans exception. Le contenu reste visible.
 * — rien ne dépend du script pour être lisible : l'état de départ n'est posé que si
 *   le script tourne (classe `e-motion-on` sur <html>), donc un échec de chargement
 *   rend la page normale au lieu d'une page vide.
 * — on n'anime que `opacity` et `transform`, les deux seules propriétés que le
 *   navigateur compose sans repeindre la page.
 */
(function () {
  var racine = document.documentElement;
  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduit.matches || !('IntersectionObserver' in window)) return;

  var CIBLES = [
    '.estrora-duo__media', '.estrora-duo__panneau',
    '.estrora-tailles__intro-bloc', '.estrora-tailles__exemple', '.estrora-tailles__schema',
    '.estrora-tailles__carte', '.estrora-grille__tete', '.estrora-grille__carte',
    '.estrora-univers__tete', '.e-card', '.estrora-manifeste', '.estrora-faq'
  ].join(',');

  function preparer() {
    racine.classList.add('e-motion-on');
    var elements = document.querySelectorAll(CIBLES);
    var groupes = new Map();

    elements.forEach(function (el) {
      if (el.dataset.eAnim) return;
      el.dataset.eAnim = '1';
      // Décalage en cascade entre frères : c'est ce qui fait lire une rangée
      // comme une rangée, au lieu de quatre blocs qui sautent ensemble.
      var parent = el.parentElement;
      var rang = groupes.get(parent) || 0;
      groupes.set(parent, rang + 1);
      el.style.setProperty('--e-retard', Math.min(rang, 5) * 70 + 'ms');
      observateur.observe(el);
    });
  }

  var observateur = new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('e-vu');
      observateur.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.06 });

  // Horizon fait défiler `.page-wrapper` au-dessus de 990 px : sans racine explicite,
  // l'observateur écoute la fenêtre, qui ne bouge jamais, et rien n'apparaît.
  var conteneur = document.querySelector('.page-wrapper');
  if (conteneur && conteneur.scrollHeight > window.innerHeight + 40 &&
      document.documentElement.scrollHeight <= window.innerHeight + 40) {
    observateur = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('e-vu');
        observateur.unobserve(e.target);
      });
    }, { root: conteneur, rootMargin: '0px 0px -12% 0px', threshold: 0.06 });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preparer);
  } else {
    preparer();
  }

  // Rangée produits : on signale par une ombre de bord qu'il reste des pièces à
  // droite, et on la retire une fois la fin atteinte. Aucune flèche ajoutée — le
  // geste natif suffit, et une flèche de plus serait un bouton de plus à rater.
  document.querySelectorAll('.estrora-grille__liste').forEach(function (liste) {
    function etat() {
      var reste = liste.scrollWidth - liste.clientWidth - liste.scrollLeft;
      liste.classList.toggle('e-suite', reste > 12);
      liste.classList.toggle('e-debut', liste.scrollLeft > 12);
    }
    liste.addEventListener('scroll', etat, { passive: true });
    window.addEventListener('resize', etat);
    etat();
  });
})();
